import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>     {/* ✅ Wrap here ONLY ONCE */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// ✅ This is perfectly fine — no changes needed
reportWebVitals();
